import { AppBar, MenuItemLink, UserMenu } from 'react-admin';
import * as React from 'react';
import { FC } from "react";
import "./index.css";
import AccountCircleIcon from '@material-ui/icons/AccountCircle';

const ConfigurationMenu = React.forwardRef<any, any>((props, ref) => {
    return (
        <MenuItemLink
            ref={ref}
            to="/profile"
            primaryText="Profile"
            leftIcon={<AccountCircleIcon />}
            onClick={props.onClick}
            sidebarIsOpen
        />
    );
});

const CustomUserMenu = (props: any) => (
    <UserMenu {...props}>
        <ConfigurationMenu />
    </UserMenu>
);


const CustomAppBar:FC = (props) => {
    return (
        <AppBar {...props} elevation={1} userMenu={<CustomUserMenu />}>
            <h3>Raffle House</h3>
        </AppBar>
    );
};

export default CustomAppBar;